//Navbar.js

const justifyMap = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
};

export default function Navbar({ placement = "end", children }) {
  return (
    <nav className="navbar">
      <ul className={`navbar-nav flex-row ${justifyMap[placement]}`}>
        {children}
      </ul>
    </nav>
  );
}

// const Navbar = (props) => {
//   return (
//     <nav className="navbar">
//       <ul className="navbar-nav flex-row">{props.children}</ul>
//     </nav>
//   );
// };

// export default Navbar;
